import { Col, Row, Steps } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import SignupStep1 from '../../components/auth/SignupStep1';
import {
  RegisterParams,
  Enterprise,
  registerMemberAsync,
  registerAdminAsync,
} from '../../modules/auth';
import { useDispatch } from 'react-redux';
import qs from 'qs';
import { RouteComponentProps } from 'react-router-dom';
import SignupStep6 from '../../components/auth/SignupStep6';
import VerifyUserPhone from '../../components/auth/VerifyUserPhone';
import { requestAuthCode, verifyAuthCode } from '../../api/constlink';
import SignupStep4 from '../../components/auth/SignupStep4';
import SelectAddressModal from '../../components/auth/SelectAddressModal';
import VerifyCorporateNumber from '../../components/auth/VerifyCorporateNumber';
import client from '../../api/client';

const StyledDiv = styled.div`
  .steps-content {
    min-height: 200px;
    margin-top: 16px;
    padding-top: 80px;
    text-align: center;
    background-color: #fafafa;
    border: 1px dashed #e9e9e9;
    border-radius: 2px;
  }

  .steps-action {
    margin-top: 24px;
  }
  [data-theme='dark'] .steps-content {
    margin-top: 16px;
    border: 1px dashed #303030;
    background-color: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    padding-top: 80px;
  }
`;

const { Step } = Steps;
const steps = [
  {
    title: '기본정보 등록',
  },
  {
    title: '휴대전화번호 인증',
  },
  {
    title: '사업자등록번호 인증',
  },
  {
    title: '회사정보 등록',
  },
  {
    title: '회원가입완료',
  },
];

interface SignupContainer3Props {
  userData: any;
}

function SignupContainer3({
  match,
  history,
}: RouteComponentProps<SignupContainer3Props>) {
  const { Base64 } = require('js-base64');
  const {
    userData,
    enterpriseData,
    bidChanceId,
    enterpriseId,
    applicationId,
    token,
    isMobileApp,
  } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [user, setUser] = useState<any>();
  const [queryStringData, setQueryStringData] = useState<any>({});
  const [authCode, setAuthCode] = useState<any>(null);
  const [verifiedAuthCode, setVerifiedAuthCode] = useState<any>(null);
  // const [gongjongs, setGongjongs] = useState<Tag[]>();
  // const [subcontractTypes, setSubcontractTypes] = useState<Tag[]>();
  const [updatedAddress, setUpdatedAddress] = useState<any>();
  const [enterprise, setEnterprise] = useState<any>();
  const [visible, setVisible] = useState<boolean>(false);
  const [verifiedCorporateNumber, setVerifiedCorporateNumber] =
    useState<any>(null);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && isMobileApp === 'true') {
      // if (process.env.NODE_ENV === 'development') {
      client.defaults.baseURL = 'http://10.0.2.2:4001/v1';
    }
    // (async () => {
    //   setGongjongs(await getEnterpriseTags('gongjong'));
    // })();
    // (async () => {
    //   setSubcontractTypes(await getEnterpriseTags('subcontractType'));
    // })();
  }, [isMobileApp]);

  useEffect(() => {
    let _queryStringData: any;
    if (userData !== undefined) {
      const _userData = Base64.decode(userData as string);
      const arrUserData: string[] = _userData
        .split(',')
        .map((value: any) => value.trim());
      _queryStringData = {
        email: arrUserData[0],
        enterpriseId,
        applicationId,
        token,
      };
      if (arrUserData.length > 1) {
        _queryStringData.name = decodeURI(arrUserData[1]);
        _queryStringData.personalPhone = arrUserData[2];
      }
      setQueryStringData({
        ..._queryStringData,
      });
    }
    if (enterpriseData !== undefined) {
      const _enterpriseData = Base64.decode(enterpriseData as string);
      const arrEnterpriseData: string[] = _enterpriseData
        .split(',')
        .map((value: any) => value.trim());
      if (arrEnterpriseData.length === 0) return;
      setEnterprise({
        name: decodeURI(arrEnterpriseData[0]),
        type1: arrEnterpriseData[1],
        representative: decodeURI(arrEnterpriseData[2]),
      });
    }
  }, [
    bidChanceId,
    enterpriseId,
    applicationId,
    userData,
    enterpriseData,
    token,
    Base64,
  ]);

  const handlePrevStep = useCallback(() => {
    setStep(step - 1);
  }, [step]);

  const onFinishStep1 = (data: any) => {
    setUser({ ...data });

    setStep(step + 1);
    setQueryStringData({ ...queryStringData, ...data });
  };

  const moveToMainPage = (enterpriseId: string) => {
    history.push(`/enterprises/${enterpriseId}/main`);
  };

  const _requestAuthCode = async (data: any) => {
    try {
      await requestAuthCode({ data });
      setAuthCode({ message: '인증코드를 요청하였습니다.', type: 'success' });
    } catch (error) {
      setAuthCode({
        message: '인증코드 요청을 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const _verifyAuthCode = async (data: any) => {
    try {
      await verifyAuthCode({ data });
      setVerifiedAuthCode({
        message: '휴대전화 인증 성공 하였습니다. 아래 다음 버튼을 클릭하세요.',
        type: 'success',
      });
    } catch (error) {
      setVerifiedAuthCode({
        message: '휴대전화 인증 실패 하였습니다.',
        type: 'danger',
      });
    }
  };

  const selectEnterpriseAddress = (value: any) => {
    setUpdatedAddress(value.address);
    setVisible(false);
  };

  const selectAddressModalOnCancel = () => setVisible(false);
  const openSelectAddressModal = () => setVisible(true);

  // 관리자 등록
  const onCreate = async (_enterprise: Enterprise) => {
    setEnterprise({ ..._enterprise });
    const params: RegisterParams = {
      user,
      enterprise: { ...enterprise, ..._enterprise, type1: '1' },
      applicationId: queryStringData.applicationId,
      token: queryStringData.token,
    };
    dispatch(registerAdminAsync.request(params));
    setStep(step + 1);
  };

  const updateUserPhone = async (personalPhone: string) => {
    setUser({ ...user, personalPhone });

    // 초대된 직원 등록
    if (queryStringData.enterpriseId !== undefined) {
      const params: RegisterParams = {
        user: { ...user, personalPhone },
        enterpriseId: queryStringData.enterpriseId,
        token: queryStringData.token,
      };
      dispatch(registerMemberAsync.request(params));
      setStep(step + 3);
      return;
    }

    setStep(step + 1);
  };

  const updateCorporateNumber = async (corporateNumber: any) => {
    // if (isExistedCoporate) {
    //   /**
    //    * 이미 가입된 회사의 직원 등록
    //    */
    //   const params: RegisterParams = {
    //     user,
    //     enterpriseId: queryStringData.enterpriseId,
    //     token: queryStringData.token,
    //   };
    //   dispatch(registerMemberAsync.request(params));
    //   setStep(step + 2);
    // } else {
    //   setEnterprise({ corporateNumber });
    //   setStep(step + 1);
    // }
    setEnterprise({ corporateNumber });
    setStep(step + 1);
  };

  const moveToGCVideo = () => {
    console.log('moveToGCVideo');
  };

  const moveToSCVideo = () => {
    console.log('moveToSCVideo');
    window.open('https://youtu.be/0NPxMh7298o', '_blank')!.focus();
  };

  return (
    <StyledDiv>
      {/* {isMobileApp === undefined && (
        <Row
          justify="center"
          style={{ marginTop: '30px', marginBottom: '30px' }}
        >
          <Col>
            <Title level={2}>하이공사 회원가입</Title>
          </Col>
        </Row>
      )} */}
      <Row justify="center" style={{ marginTop: '10px' }}>
        <Col span={18}>
          <Steps current={step}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
        </Col>
      </Row>
      {step === 0 && queryStringData && (
        <SignupStep1
          isMobileApp={isMobileApp === 'true'}
          userData={queryStringData}
          onSuccess={onFinishStep1}
        />
      )}

      {step === 1 && (
        <VerifyUserPhone
          user={user}
          authCode={authCode}
          verifiedAuthCode={verifiedAuthCode}
          successBtnMsg={'다음'}
          requestAuthCode={_requestAuthCode}
          verifyAuthCode={_verifyAuthCode}
          onPrev={() => {
            handlePrevStep();
          }}
          updateUserPhone={updateUserPhone}
        />
      )}
      {step === 2 && (
        <VerifyCorporateNumber
          user={user}
          successBtnMsg={'다음'}
          verifiedCorporateNumber={verifiedCorporateNumber}
          onPrev={() => {
            setAuthCode(null);
            setVerifiedAuthCode(null);
            handlePrevStep();
          }}
          updateCorporateNumber={updateCorporateNumber}
        />
      )}
      {step === 3 && (
        <SignupStep4
          data={enterprise}
          // gongjongs={gongjongs}
          // subcontractTypes={subcontractTypes}
          updatedAddress={updatedAddress}
          onCreate={onCreate}
          onPrev={() => {
            setVerifiedCorporateNumber(null);
            handlePrevStep();
          }}
          openSelectAddressModal={openSelectAddressModal}
        />
      )}
      {step === 4 && (
        <SignupStep6
          isMobileApp={isMobileApp === 'true'}
          moveToGCVideo={moveToGCVideo}
          moveToSCVideo={moveToSCVideo}
          moveToMainPage={moveToMainPage}
        />
      )}
      {visible && (
        <SelectAddressModal
          selectAddress={selectEnterpriseAddress}
          onCancel={selectAddressModalOnCancel}
          visible={visible}
        />
      )}
    </StyledDiv>
  );
}

export default SignupContainer3;
